const MenuSectionHeader = (props) => {
  return (
    <button className="menu-section-header" onClick={props.onSectionClick}>
      <h2 className="menu-section-header-text">+ new section</h2>
    </button>
  );
};

export default MenuSectionHeader;
